import {passwordChange as types} from '../actions/actiontypes'
import formReducer from './formReducer'

const passwordChangeReducer = formReducer(types)

export {passwordChangeReducer}
